<template>
  <div class="blog-detail-wrapper p-0">
    <h4>Telkom Product Tree</h4>
    <b-card class="mt-2 pt-3" style="overflow-y:auto">
      <TreeChart :json="treeData" />
    </b-card>
    <!--/ blogs -->
  </div>
</template>

<script>
import TreeChart from "vue-tree-chart";
import { BAvatar,BLink,BCardText,BCard, BContainer, BRow, BCol, BButton } from 'bootstrap-vue'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'

export default {
  components: {
    BAvatar,
    ContentWithSidebar,
    BCardText,
    BCard,
    BLink,
    BContainer,
    BRow,
    BCol,
    BButton,
    TreeChart
  },

  data() {
    return {
      treeData: {
        
      }
    }
  },

  filters: {
    
  },

  mounted() {
    this.fetchTree()
  },

  methods: {
    fetchTree() {
      this.$http.get('/tree').then(response => { 
        this.treeData = response.data
      })
    }
  },
}
</script>

<style scoped>
td {
  padding: 0 0 1.5rem 0 !important;
}

.name {
  height: 4em !important;
  line-height: 1.3em;
}
</style>